import { render, staticRenderFns } from "./Chatwoot.vue?vue&type=template&id=51e2aabd&scoped=true&"
import script from "./Chatwoot.vue?vue&type=script&lang=js&"
export * from "./Chatwoot.vue?vue&type=script&lang=js&"
import style0 from "./Chatwoot.vue?vue&type=style&index=0&id=51e2aabd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2aabd",
  null
  
)

export default component.exports